import { useAuth0 } from '@auth0/auth0-react';
import { ProtectedRoute } from './ProtectedRoute';

/**
 * Route only accessible by authenticated users
 *
 * @returns Outlet if user is authenticated, redirect to login page otherwise
 */
export const AuthenticatedRoute = () => {
  const { isAuthenticated } = useAuth0();
  return <ProtectedRoute isAllowed={isAuthenticated} redirectPath='/login' />;
};
